import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons/faInfoCircle';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TooltipDirective, TooltipPosition } from '../../ui/tooltip/tooltip.directive';

@Component({
  selector: 'andor-mat-toggle-wrapper',
  standalone: true,
  imports: [FaIconComponent, TooltipDirective],
  templateUrl: './mat-toggle-wrapper.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './mat-toggle-wrapper.scss',
})
export class MatToggleWrapper {
  protected readonly faInfoCircle = faInfoCircle;

  @Input() tooltipDirection: TooltipPosition = 'above';
  @Input() tooltipText?: string;
  @Input() label?: string;
}
